import {
  GET_REFERRAL_SHARE_LINK_URL,
  ONE_LINK_API
} from 'src/utils/constants/ApiConstants';
import {
  HTTP_HEADER_KEYS,
  HTTP_METHODS
} from 'src/utils/constants/HttpMethodsConstants';
import { Share_Constant } from 'src/utils/constants/stringConstants';

import { httpService } from '../fetch/HttpService';

export const oneLinkApiCall = async (shareURL: string, pid?: string) => {
  const requestObj = {
    url: shareURL,
    pid: pid || Share_Constant.SHARE_CTA_CONTENT_CONSUMPTION
  };
  try {
    const response = await httpService.fetchApiData({
      url: ONE_LINK_API,
      type: HTTP_METHODS.POST,
      body: requestObj
    });
    if (response && Object.keys(response).length === 1) {
      return response?.url;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error while sharing url: ', error);
  }
};

export const validateShareLinkData = (apiData: any) => {
  return apiData?.shareLink || false;
};

export const getReferralShareLink = async () => {
  let shareLinkData = '';
  try {
    const headers = [
      HTTP_HEADER_KEYS.DEVICE_ID,
      HTTP_HEADER_KEYS.ESK,
      HTTP_HEADER_KEYS.AUTHORIZATION
    ];
    // TODO :: Check why referral link is generated on share.
    const shareDataResponse = await httpService.fetchApiData({
      url: GET_REFERRAL_SHARE_LINK_URL,
      type: HTTP_METHODS.GET,
      headers
    });
    if (validateShareLinkData(shareDataResponse)) {
      shareLinkData = shareDataResponse.shareLink;
    }
  } catch (error) {
    console.error('Error while sharing url: ', error);
  }
  return shareLinkData;
};
